export const Dependence = {
  FS: 'FS',
  SF: 'SF',
};

export const TaskType = {
  CONSTRUCTION: 'CONSTRUCTION',
  OTHER: 'OTHER',
  BOTH: 'BOTH',
};

export const DependenceOption = [
  { value: Dependence.FS, label: 'Befejezés → Kezdés' },
  { value: Dependence.SF, label: 'Kezdés → Befejezés' },
];

export const TaskTypeOption = [
  { value: TaskType.CONSTRUCTION, label: 'Kivitelezés' },
  { value: TaskType.OTHER, label: 'Egyéb feladat' },
  { value: TaskType.BOTH, label: 'Mindkettő' },
];

export const TaskResponsibleTypeEnum = {
  USER: 'USER',
  USERGROUP: 'USERGROUP',
  WORKER: 'WORKER',
  BUSINESSPARTNER: 'BUSINESSPARTNER',
};
